import { render, staticRenderFns } from "./PaymentPassIntro.vue?vue&type=template&id=00fb8eac&scoped=true"
import script from "./PaymentPassIntro.vue?vue&type=script&lang=js"
export * from "./PaymentPassIntro.vue?vue&type=script&lang=js"
import style0 from "./PaymentPassIntro.vue?vue&type=style&index=0&id=00fb8eac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fb8eac",
  null
  
)

export default component.exports